import { FeatureFlag } from '@/types/featureFlag';
import { useFeatureFlagEnabled } from '@/utils/useFeatureFlagEnabled';

/**
 * Wide-table treatment props for visit tables (PRD-690): the sticky header is
 * always on, while the horizontal scroll arrows and pinned Actions column are
 * each gated behind an org feature flag (both default off). Mirrors the All
 * Visits table so every visit table lights up together when a flag flips.
 *
 * Spread onto UnifiedVisitsAndRequestsTable / UnifiedVisitOccurrencesTable.
 */
export const useWideVisitTableTreatment = () => ({
    stickyHeader: true,
    horizontalScrollButtons: useFeatureFlagEnabled(FeatureFlag.DASHBOARD_TABLE_HORIZONTAL_BUTTONS),
    pinActions: useFeatureFlagEnabled(FeatureFlag.DASHBOARD_TABLE_PINNED_ACTIONS),
});
